export const MERCH_CARD = 'merch-card';
export const CALCULATOR = 'calculator';
export const SPLASH_PAGE_CARD = 'splash-page-card';
export const STARTER_SUITE_CARD = 'starter-suite-card';
export const SUITE_CARD = 'suite-card';
export const FREE_CARD = 'free-card';
export const SUITE_CALCULATOR = 'suite-calculator';
export const CMS_CARD = 'cms-card';
export const MIGRATE_YOUR_SITE = 'migrate-your-site';
export const MC_SIDEGRADE_MODAL = 'mc-sidegrade-modal';
export const CREATE_A_BUNDLE = 'create-a-bundle';
export const BUNDLE_CARD = 'bundle-card';
export const PAID_VS_FREE_USERS_MODAL = 'paid-vs-free-users-modal';
export const PRODUCT_PAGE_HEADER = 'product-page-header';
export const APP = 'pricing-pages';
export const WHY_GO_HUBSPOT_CARD = 'why-go-hubspot-card';
export const INTERSTITIAL = 'interstitial';
export const EBX633_LP = 'ebx633-landing-page';
export const SCREENS = {
  PRODUCTS_PLANS: 'products-plans',
  CREATE_BUNDLE: 'create-bundle',
  GROWTH_SUITE: 'growth-suite',
  SUITE: 'suite',
  ERROR: 'error',
  CONTACT_CONFIRMATION: 'contact-confirmation',
  SUITE_CONTACT_CONFIRMATION: 'suite-contact-confirmation',
  MC_CONTACT_CONFIRMATION: 'mc-contact-confirmation',
  CONTACT_SALES: 'contact-sales',
  LEGACY_INTERSTITIAL: 'legacy-interstitial',
  SUITE_STARTER: 'suite-starter'
};